import {
  useMutation,
  ApolloClient,
  NormalizedCacheObject,
} from '@apollo/client'
import { captureWarning } from 'lib/monitoring'
import { VALIDATE_WALLET_INVITATION_MUTATION } from 'lib/apollo/schema'

// Types
export interface VerifyWalletTokenVariables {
  token: string
}

export interface VerifyWalletTokenResponse {
  validateWalletInvitation: {
    success: boolean
    message: string
    data?: {
      id: string
      fullName: string
      email: string
      phone?: string
      patientId: string
      surgeryId: string
      patientMRN?: string
      token: string
      expiresAt: string
      dateOfBirth?: string
    }
  }
}

/**
 * Hook for verifying wallet card tokens
 * Uses the validateWalletInvitation GraphQL mutation from the iservices API
 */
export const useVerifyWalletTokenMutation = (
  client?: ApolloClient<NormalizedCacheObject>
) => {
  const [mutate, { loading, error, data }] = useMutation<
    VerifyWalletTokenResponse,
    { validateWalletInvitationInput: { token: string } }
  >(VALIDATE_WALLET_INVITATION_MUTATION, {
    onError: (error) => {
      captureWarning(error)
    },
    ...(client ? { client } : {}),
  })

  return {
    verifyToken: mutate,
    loading,
    error,
    data: data?.validateWalletInvitation,
  }
}
